import React, {useEffect, useState} from 'react'
import axios from 'axios'
import LoadingOverlay from 'react-loading-overlay'

import './DirectorioBanner.css'

function DirectorioBanner() {
  const url = 'https://puntosurgdl.com/backend/'

  const [count, setCount] = useState(0)

  const [spinnerIsActive, setSpinnerIsActive] = useState(false)
  const [videoInfo, setVideoInfo] = useState('')
  const [imgInfo, setImgInfo] = useState('')
  const [checkBannerMode, setCheckBannerMode] = useState(false)

  useEffect(() => {
    getBannerInfo()
  }, [])

  const getBannerInfo = () => {
    axios
      .get(url + 'getDirectorioBanner.php')
      .then((response) => {
        const videoElement = document.getElementById('directorio-video-fondo')
        const sourceElement = document.createElement('source')
        sourceElement.setAttribute('id', 'directorio-video-fondo-source')
        sourceElement.setAttribute('src', response.data.data[0].url)
        videoElement.appendChild(sourceElement)

        setVideoInfo(response.data.data[0])
        setImgInfo(response.data.data[1])
        setCheckBannerMode(parseInt(response.data.data[0].mode))
        if (parseInt(response.data.data[0].mode)) {
          document.getElementById('video-mode').classList.add('d-none')
          document.getElementById('img-mode').classList.remove('d-none')
        } else {
          document.getElementById('video-mode').classList.remove('d-none')
          document.getElementById('img-mode').classList.add('d-none')
        }
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const onChangeCheckMode = (event) => {
    let bannerMode = false
    if (event.target.checked) {
      console.log('is checked')
      document.getElementById('video-mode').classList.add('d-none')
      document.getElementById('img-mode').classList.remove('d-none')
      document.getElementById('card-subtitle-video').classList.add('d-none')
      document.getElementById('card-subtitle-img').classList.remove('d-none')
      bannerMode = 1
    } else {
      document.getElementById('video-mode').classList.remove('d-none')
      document.getElementById('img-mode').classList.add('d-none')
      document.getElementById('card-subtitle-video').classList.remove('d-none')
      document.getElementById('card-subtitle-img').classList.add('d-none')
      console.log('is NOT checked')
      bannerMode = 0
    }

    setCheckBannerMode((current) => !current)

    const data = {
      name: 'directorio_img_mode',
      content: bannerMode,
    }

    axios
      .post(url + 'updateColumnIsActive.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res)
          setCheckBannerMode(bannerMode)
        },
        (error) => {
          alert(error)
        }
      )
  }

  const uploadFile = () => {
    const data = new FormData()

    if (checkBannerMode) {
      if (document.getElementById('directorio-img-file').files.length !== 0) {
        setSpinnerIsActive(true)
        for (let i = 0; i < document.getElementById('directorio-img-file').files.length; i++) {
          data.append('file[]', document.getElementById('directorio-img-file').files[i])
        }

        data.append('name', 'directorio-img-fondo')

        axios
          .post(url + 'uploadBannerDirectorio.php', data, {
            // receive two parameter endpoint url ,form data
          })
          .then(
            (res) => {
              // then print response status
              // console.log(res.data)
              // setConceptos(res.data.data)
              // handleCloseNewConcepto()
              console.log(res.data)
              document
                .getElementById('directorio-img-fondo')
                .setAttribute('src', res.data.data[1].url)
              document.getElementsByName('directorio-img-file')[0].value = null
              setSpinnerIsActive(false)
            },
            (error) => {
              alert(error)
            }
          )
      } else {
        console.log('vacío')
      }
    } else {
      if (document.getElementById('directorio-video-file').files.length !== 0) {
        setSpinnerIsActive(true)
        for (let i = 0; i < document.getElementById('directorio-video-file').files.length; i++) {
          data.append('file[]', document.getElementById('directorio-video-file').files[i])
        }

        data.append('name', 'directorio-video-fondo')

        axios
          .post(url + 'uploadBannerDirectorio.php', data, {
            // receive two parameter endpoint url ,form data
          })
          .then(
            (res) => {
              // then print response status
              // console.log(res.data)
              // setConceptos(res.data.data)
              // handleCloseNewConcepto()
              console.log(res.data)
              document
                .getElementById('directorio-video-fondo-source')
                .setAttribute('src', res.data.data[0].url)
              document.getElementById('directorio-video-fondo').load()
              document.getElementsByName('directorio-video-file')[0].value = null
              setSpinnerIsActive(false)
            },
            (error) => {
              alert(error)
            }
          )
      } else {
        console.log('vacío')
      }
    }
  }

  return (
    <LoadingOverlay active={spinnerIsActive} spinner text='Cargando...'>
      <div className='row g-5'>
        <div className='col-lg-12'>
          <div className='card card-custom card-stretch shadow mb-5 video-banner'>
            <div className='card-header'>
              <h3 className='card-title'>Banner Directorio</h3>
              <h5 className='card-subtitle-video' id='card-subtitle-video'>
                Subir un archivo .mp4, de no más de 40MB de peso.
              </h5>
              <h5 className='card-subtitle-img d-none' id='card-subtitle-img'>
                Las imágenes deben tener una medida de 1920px por 100px y no pesar más de 1MB
              </h5>
            </div>
            <div className='card-body'>
              <div id='video-mode'>
                <p>Video Actual</p>
                <video id='directorio-video-fondo' controls>
                  {/* <source id='home-video-fondo-source' src={videoInfo.fullUrl} /> */}
                  Tu navegador no soporta la tag video.
                </video>

                <div className='row'>
                  <div className='form-group col-md-12'>
                    <label>Cambiar video:</label>
                    <input
                      type='file'
                      className='form-control'
                      id='directorio-video-file'
                      name='directorio-video-file'
                      accept='.mp4'
                    />
                  </div>
                </div>
              </div>

              <div id='img-mode' className=''>
                <p>Imagen Actual:</p>
                <img src={imgInfo.url} id='directorio-img-fondo' />

                <div className='row'>
                  <div className='form-group col-md-12'>
                    <label>Cambiar imagen:</label>
                    <input
                      type='file'
                      className='form-control'
                      id='directorio-img-file'
                      name='directorio-img-file'
                      accept='image/*'
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='card-footer'>
              <div className='form-check form-switch form-check-custom form-check-solid mt-8'>
                <input
                  className='form-check-input desc-active'
                  type='checkbox'
                  id='banner-mode'
                  checked={checkBannerMode}
                  onChange={(e) => onChangeCheckMode(e)}
                />
                <label className='form-check-label' for='desc-active'>
                  Activar modo imagen
                </label>
              </div>
              <div className='form-group float-end'>
                <button type='submit' className='btn btn-primary mt-6' onClick={() => uploadFile()}>
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  )
}

export {DirectorioBanner}
